export { default } from './CamPlayer';
